export function InsufficientPermissionsError() {
    return (
        <div>
            <h5>
        Your login was successful but you do not have sufficient permission to
        access the system. Please contact your manager to obtain access.
            </h5>
        </div>
    );
}
